<template>
  <div class="page-header">
    <div class="page-header-left">
      <nav class="breadcrumb-nav" aria-label="Breadcrumb">
        <ol class="breadcrumb-list">
          <li v-for="(crumb, index) in breadcrumbs" :key="index" class="breadcrumb-item">
            <router-link v-if="crumb.to" :to="crumb.to" class="breadcrumb-link">
              {{ crumb.text }}
            </router-link>
            <span v-else class="breadcrumb-current">{{ crumb.text }}</span>
            <feather-icon v-if="index < breadcrumbs.length - 1" icon="ChevronRightIcon" class="breadcrumb-separator" />
          </li>
        </ol>
      </nav>
      <h1 class="page-title">{{ title }}</h1>
      <p v-if="subtitle" class="page-subtitle">{{ subtitle }}</p>
    </div>
    <div class="page-header-right">
      <slot name="actions"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PageHeader',
  props: {
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      default: '',
    },
    breadcrumbs: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style lang="scss" scoped>
.page-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 1.5rem;
  padding: 0 0 1rem 0;
  border-bottom: 1px solid var(--sf-border-light, #e5e8f0);
}

.page-header-left {
  flex: 1;
}

.breadcrumb-nav {
  margin-bottom: 0.375rem;
}

.breadcrumb-list {
  display: flex;
  align-items: center;
  gap: 0.25rem;
  list-style: none;
  padding: 0;
  margin: 0;
}

.breadcrumb-item {
  display: flex;
  align-items: center;
  gap: 0.25rem;
}

.breadcrumb-link {
  font-size: 0.8125rem;
  color: var(--sf-text-muted, #5f6472);
  text-decoration: none;
  transition: color 0.2s ease;

  &:hover {
    color: var(--sf-primary, #5d54d4);
  }
}

.breadcrumb-current {
  font-size: 0.8125rem;
  color: var(--sf-text-primary, #2f2b3d);
  font-weight: 500;
}

.breadcrumb-separator {
  width: 14px;
  height: 14px;
  color: var(--sf-text-muted, #5f6472);
  opacity: 0.5;
}

.page-title {
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--sf-text-primary, #2f2b3d);
  margin: 0;
  line-height: 1.3;
}

.page-subtitle {
  font-size: 0.875rem;
  color: var(--sf-text-muted, #5f6472);
  margin: 0.25rem 0 0 0;
}

.page-header-right {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  flex-shrink: 0;
}

@media (max-width: 768px) {
  .page-header {
    flex-direction: column;
    gap: 1rem;
    align-items: stretch;
  }

  .page-header-right {
    justify-content: flex-start;
  }
}
</style>
